import script from "./ProductCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductCard.vue?vue&type=script&lang=ts&setup=true"

import "./ProductCard.vue?vue&type=style&index=0&id=342f7a53&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-342f7a53"]])

export default __exports__